<script>
// https://github.com/vuejs-tips/vue-the-mask
import { mask } from 'vue-the-mask'
import { authComputed, merchantComputed } from '@state/helpers'

import Layout from '@layouts/main'
import formatDate, { timeDiffInMinutes, formatLunar } from '@utils/format-date'
import CountryCallingCodePicker from '@components/CountryCallingCodePicker'
import ModalTerms from '@components/modal/ModalTerms'
import _findIndex from 'lodash/findIndex'
import BookingSectionToggle from './components/BookingSectionToggle'
import BookingSectionOrder from './components/BookingSectionOrder'
import ModalDeduct from '@components/modal/ModalDeduct'
import formatProductType from '@utils/format-product-type'

export default {
  page() {
    return {
      title: this.order ? this.order.merchant.name : this.currentMerchant.name,
    }
  },
  components: {
    Layout,
    CountryCallingCodePicker,
    ModalTerms,
    // BookingSectionCheckbox,
    // BookingSectionRadio,
    BookingSectionOrder,
    BookingSectionToggle,
    ModalDeduct,
  },
  filters: {
    formatDate,
    formatLunar,
  },
  directives: { mask },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    checkoutCart: {
      type: Object,
      required: true,
    },
    checkoutType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bindCardFormData: '',
      isCodePickerActive: false,
      isTermsModalActive: false,
      isPaymentProcessing: false,
      couponProcessing: false,
      paymentMethodOption: [
        {
          text: '信用卡',
          value: 'Credit',
        },
        {
          text: 'ATM虛擬帳戶匯款',
          value: 'Vacc',
        },
      ],
      bankOption: [
        {
          text: '台灣銀行',
          value: 'BOT',
        },
        {
          text: '華南銀行',
          value: 'HNCB',
        },
        {
          text: '台新銀行',
          value: 'Taishin',
        },
      ],
      monthOptionNum: 12,
      yearOptionNum: 25, // count from 1
      step: this.checkoutCart.prepaid && this.$route.name === 'checkout-unpaid' ? 1.5 : 1,
      bStep: 0,
      couponCode: '',
      couponInfo: '',
      /* formData: {
        fullName: '白日夢測試',
        gender: 'male',
        phoneCode: '+886',
        phoneNumber: '0912345678',
        email: 'service@daydream-lab.com',
        note: '',
        agreeTerms: true, // true
        card: '4000 2211 1111 1111', // https://en.wikipedia.org/wiki/Payment_card_number
        expMonth: null, // null
        expYear: null, // null
        cvc: '',
        couponCode: '',
        extrafield: {
          byOrder: {},
          bySize: [],
        },
        paymentMethod: 'Credit',
        bankType: null,
        autoRenew: 0
      }, */
      formData: {
        fullName: '',
        gender: 'male',
        phoneCode: '+886',
        phoneNumber: '',
        email: '',
        note: '',
        agreeTerms: true, // true
        card: '', // https://en.wikipedia.org/wiki/Payment_card_number
        expMonth: null, // null
        expYear: null, // null
        cvc: '',
        couponCode: '',
        extrafield: {
          byOrder: {},
          bySize: []
        },
        paymentMethod: 'Credit',
        bankType: null,
        autoRenew: 0
      },
      isDeductProcessing: false,
      isModalDeductActive: false,
      deductCallBack: null,
      toggleFormValid: [],
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    isDisabledRenew() {
      return this.formData.paymentMethod === 'Credit' && ( window.globalData.APP_ENV === 'local' || window.globalData.APP_ENV === `{{config('app.env')}}` )
    },
    isDisabledCredit() {
      return this.currentMerchant.cashflowSetting !== 1;
    },
    hasRenew() {
      return Object.values(this.checkoutCart.params).some(item => item.canAutoRenew);
    },
    /**
     * 今年
     * @return {Number} Year YYYY
     */
    currentYear() {
      return new Date().getFullYear()
    },
    /**
     * 購物車商品類型
     * @return {String} 商品：course, service, reservation, guide, 非商品：prepaid
     */
    cartProductType() {
      if (this.checkoutType === 'product') {
        return this.checkoutCart.product
          ? this.checkoutCart.product.type
          : 'activity'
      } else {
        return 'prepaid'
      }
    },
    /**
     * 購物車商品備註
     * @return {Object} label, required
     */
    cartProductNote() {
      return {
        label: this.checkoutCart.product
          ? this.checkoutCart.product.noteLabel
          : undefined,
        required: this.checkoutCart.product
          ? this.checkoutCart.product.noteLabel &&
          this.checkoutCart.product.noteRequired
          : false,
      }
    },
    /**
     * 表單驗證沒過
     * @return {Boolean}
     */
    isFormValid() {
      // 需重寫
      return (
        this.isFieldsValid ||
        this.isOrderExtrafieldFormValid ||
        this.isSizeExtrafieldValid ||
        this.isToggleFormValid
      )
    },
    /**
     * 有欄位驗證沒過
     * @return {Boolean}
     */
    isFieldsValid() {
      return Object.keys(this.fields).some((key) => {
        return this.fields[key].invalid && !(key === 'coupon' && this.fields[key].invalid)
      })

      // coupon
    },
    isToggleFormValid() {
      const compute = this.toggleFormValid.every((item) => {
        return !item
      });

      return !compute && this.step === 1.5
      //
    },
    /**
     * 有額外欄位驗證沒過
     * @return {Boolean}
     */
    isOrderExtrafieldFormValid() {
      if (this.hasExtrafieldsByOrder && this.step === 1.5) {
        const requiredExtrafield = this.extrafieldsByOrder.filter((item) => {
          return item.required
        });

        const compute = requiredExtrafield.every((item) => {
          return (
            this.formData.extrafield.byOrder[item.id] &&
            ((typeof this.formData.extrafield.byOrder[item.id] === 'object' &&
              this.formData.extrafield.byOrder[item.id].length > 0) ||
              typeof this.formData.extrafield.byOrder[item.id] !== 'object') &&
            this.formData.extrafield.byOrder[item.id] !== null &&
            this.formData.extrafield.byOrder[item.id] !== {}
          )
        });

        return !compute
      } else {
        return false
      }
    },
    /**
     * 有額外欄位驗證沒過
     * @return {Boolean}
     */
    isSizeExtrafieldValid() {
      if (this.hasExtrafieldsBySize && this.step === 1.5) {
        const extrafieldsBySize = this.extrafieldsBySize || [];

        const requiredExtrafield = extrafieldsBySize[0].filter((item) => {
          return item.required && !item.adminEdit
        });

        return !this.formData.extrafield.bySize.every((item) => {
          return requiredExtrafield.every((requiredItem) => {
            return (
              item[requiredItem.id] &&
              ((typeof item[requiredItem.id] === 'object' &&
                item[requiredItem.id].length > 0) ||
                typeof item[requiredItem.id] !== 'object') &&
              item[requiredItem.id] !== null &&
              item[requiredItem.id] !== {}
            )
          })
        })
      } else {
        return false
      }
    },
    /**
     * 須自動完成
     * @return {Boolean}
     */
    isAutoCompleteInfo() {
      return (this.$route.name === 'booking-prepaid-checkout' || this.$route.name === 'booking-prepaid-unpaid-checkout')
    },
    /**
     * 購物車總價
     * @return {Number}
     */
    checkoutTotal() {
      const { discount, type } = this.couponInfo;

      const percentDiscount = (value = 0, total = 1) => {
        return Math.round(total * (value / 100))
      };
      const calculateDiscount = (type = 'fixed', value = 0, total = 1) => {
        return (
          total - (type === 'fixed' ? value : percentDiscount(value, total))
        )
      };
      return this.couponInfo
        ? calculateDiscount(type, discount, this.checkoutCart.paramsPriceTotal)
        : this.checkoutCart.paramsPriceTotal
    },
    /**
     * 購物車時間間隔
     * @return {String} 預計活動時間顯示格式化成(月、天、小時、分鐘)
     */
    cartTimeInterval() {
      const dateDiff = timeDiffInMinutes(`${this.checkoutCart.time.startTime}:00`, `${this.checkoutCart.time.endTime}:00`);

      if (dateDiff > 60 * 24 * 30) {
        return this.$tc(
          'global.ABOUT_TIME_MOUTH',
          dateDiff / (60 * 24 * 30),
          {
            minute: Math.floor(dateDiff / (60 * 24 * 30)),
          } /* (預計{minute}個月) */
        )
      } else if (dateDiff > 60 * 24) {
        return this.$tc(
          'global.ABOUT_TIME_DAY',
          dateDiff / (60 * 24),
          { minute: Math.floor(dateDiff / (60 * 24)) } /* (預計{minute}天) */
        )
      } else if (dateDiff > 60) {
        return this.$tc(
          'global.ABOUT_TIME_HOUR',
          dateDiff / 60,
          { minute: Math.floor(dateDiff / 60) } /* (預計{minute}小時) */
        )
      } else {
        return this.$tc(
          'global.ABOUT_TIME_MINUTE',
          dateDiff,
          { minute: Math.floor(dateDiff) } /* (預計{minute}分鐘) */
        )
      }
    },
    /**
     * 免費訂單
     * @return {Boolean}
     */
    isFreeOrder() {
      return this.checkoutTotal === 0 || !!this.checkoutCart.prepaid
    },
    /**
     * 未付款訂單
     * @return {Boolean}
     */
    isUnpaidCheckout() {
      return this.$route.name === 'checkout-unpaid'
    },
    /**
     * 有額外欄位(bySize)
     * @return {Boolean}
     */
    hasExtrafieldsBySize() {
      if (this.$route.name === 'checkout-unpaid') {
        const customerInfos =
          this.order.customerInfos.length > 0 ? this.order.customerInfos : false;
        const orderExtrafields = customerInfos
          ? customerInfos[0].bySizeExtrafields
          : {};

        return Object.keys(orderExtrafields).length > 0
      } else {
        const product = this.checkoutCart.product || {};
        const orderExtrafields = product.orderExtrafields || {};

        return orderExtrafields.bySize
      }
    },
    /**
     * 有額外欄位(byOrder)
     * @return {Boolean}
     */
    hasExtrafieldsByOrder() {
      if (this.$route.name === 'checkout-unpaid') {
        const orderExtrafields = this.order.byOrderExtrafields || {};

        return Object.keys(orderExtrafields).length > 0
      } else {
        const product = this.checkoutCart.product || {};
        const orderExtrafields = product.orderExtrafields || {};

        return orderExtrafields.byOrder
      }
    },
    /**
     * 有額外欄位
     * @return {Boolean}
     */
    hasExtrafields() {
      return this.hasExtrafieldsBySize || this.hasExtrafieldsByOrder
    },
    /**
     * 額外欄位(byOrder)
     * @return {Array}
     */
    extrafieldsByOrder() {
      if (this.hasExtrafieldsByOrder) {
        if (this.$route.name === 'checkout-unpaid') {
          return Object.keys(this.order.byOrderExtrafields).map((key) => {
            return this.order.byOrderExtrafields[key]
          })
        } else {
          return this.checkoutCart.product.orderExtrafields.byOrder || []
        }
      } else {
        return []
      }
    },
    /**
     * 額外欄位(byOrder)
     * @return {Array}
     */
    extrafieldsBySize() {
      if (this.hasExtrafieldsBySize) {
        if (this.$route.name === 'checkout-unpaid') {
          return this.order.customerInfos.map((customerInfo) => {
            return Object.keys(customerInfo.bySizeExtrafields).map((key) => {
              return customerInfo.bySizeExtrafields[key]
            })
          })
        } else {
          const orderExtrafieldsBySize = (this.checkoutCart.product.orderExtrafields.bySize || []);

          return this.checkoutCartParams.map(() => {
            return orderExtrafieldsBySize
          })
        }
      } else {
        return []
      }
    },
    /**
     * 步驟
     * @return {Array}
     */
    formatSteps() {
      return this.steps().filter((item) => {
        return item.verification()
      })
    },
    /**
     * 購物車票種
     * @return {Array}
     */
    checkoutCartParams() {
      let params = [];

      if (this.checkoutCart.params) {
        Object.keys(this.checkoutCart.params).forEach((paramAlias) => {
          for (let i = 0; i < this.checkoutCart.params[paramAlias].size; i++) {
            for (let j = 0; j < this.checkoutCart.params[paramAlias].qty; j++) {
              params.push({
                ...this.checkoutCart.params[paramAlias],
                sizeIndex: i + 1,
                qtyIndex: j + 1,
              })
            }
          }
        })
      }

      return params
    },
    /**
     * 有購物車折價券
     * @return {Array}
     */
    hasCheckoutCartCouponInfo() {
      const checkoutCart = this.checkoutCart;
      const couponInfo = checkoutCart.couponInfo || {};

      return couponInfo.title
    },
  },
  watch: {
    step: 'initbStep',
    'formData.paymentMethod': {
      handler(v, ov) {
        //  alert('aa')
      },
      deep: true,
    }
  },
  created() {
    this.initCouponValidator();
    this.initbStep();
    this.initAutoComplete();
  },
  mounted() {
    if(this.isFreeOrder) {
      this.formData.paymentMethod = 'Free';
    }

    if(this.isDisabledCredit) {
      this.formData.paymentMethod = 'Vacc';
    }

    if (this.isUnpaidCheckout) {
      this.updateFormDataFromOrder()
    }

    if (this.$route.name === 'checkout-unpaid') {
      this.updateExtrafieldsFromOrder()
    }

    document.addEventListener('keydown', this.testKeydown)
  },
  destroyed() {
    document.removeEventListener('keydown', this.testKeydown)
  },
  methods: {
    formatProductType,
    /**
     * 測試用功能
     */
    testKeydown() {
      if (
        location.hostname === 'dingsomething.daydream-lab.com' ||
        location.hostname === 'localhost' ||
        location.hostname === 'dingsomething.test'
      ) {
        const e = event || window.event;

        if (e.keyCode === 90 && e.shiftKey) {
          this.testAutoComplate()
        }
      }
    },
    /**
     * 測試用功能
     */
    testAutoComplate() {
      console.log('自動完成');
      this.formData.fullName = '測試';
      this.formData.phoneNumber = '0912345678';
      this.formData.email = 'wwww4564@gmail.com';
      this.formData.agreeTerms = true;
      this.formData.card = '4000 2211 1111 1111';
      this.formData.expMonth = 10;
      this.formData.expYear = 25;
      this.formData.cvc = '000';
    },
    initCouponValidator() {
      const checkCoupon = {
        getMessage: (field, params, data) => {
          return data
        },
        validate: (value) => {
          return this.$store
            .dispatch('booking/checkCoupon', {
              code: value,
              merchantAlias: this.checkoutCart.merchantAlias,
              productAlias: this.checkoutCart.product.alias,
              basePrice: this.checkoutCart.paramsPriceTotal,
            })
            .then((success) => {
              this.handleApplyCoupon(success.items);
              return { valid: true, data: null }
            })
            .catch((error) => {
              return {
                valid: false,
                data: this.$t(`error.${error.status}`),
              }
            })
            .finally(() => {
              this.couponProcessing = false
            })
        },
      };
      this.$validator.extend('checkCoupon', checkCoupon)
    },
    initAutoComplete() {
      if (this.$route.name === 'booking-prepaid-checkout' || this.$route.name === 'checkout') {
        this.formData.fullName = this.currentMember.fullName || '';
        this.formData.email = this.currentMember.email || '';
        this.formData.gender = this.currentMember.gender || 'male';
        this.formData.phoneCode = this.currentMember.phone.split('-')[0] || '+886';
        this.formData.phoneNumber = this.currentMember.phone.split('-')[1] || '';
      }

      if (this.$route.name === 'booking-prepaid-unpaid-checkout') {
        this.formData.fullName = this.order.fullName || '';
        this.formData.email = this.order.email || '';
        this.formData.gender = this.order.gender || 'male';
        this.formData.phoneCode = this.order.phoneCode || '+886';
        this.formData.phoneNumber = this.order.phoneNumber || '';
      }
    },
    initbStep() {
      this.bStep = _findIndex(this.formatSteps, (item) => {
        return item.value === Number(this.step)
      })
    },
    handleApplyCoupon(couponData) {
      this.couponInfo = couponData;
      this.formData.couponCode = couponData.code;
    },
    handleResetCoupon() {
      this.couponCode = '';
      this.couponInfo = '';
      this.formData.couponCode = '';
      this.$validator.reset('coupon')
    },
    handleValidCoupon(couponCode) {
      if (couponCode) {
        this.couponProcessing = true;
        this.$validator.validate('coupon', couponCode)
      }
    },
    handle3DVerify(htmlData) {
      document.getElementById('app').innerHTML = htmlData;
      document.forms[0].submit()
    },
    goToOrderDetail(order) {
      if (this.checkoutType === 'prepaid') {
        this.$router.push(this.formatLink('prepaid-order-detail', { order }))
      } else {
        this.$router.push(this.formatLink('order-detail', { order }))
      }
    },
    formatOrderExtrafieldsFromOrder() {
      const orderExtrafieldsByOrder = Object.keys(
        this.formData.extrafield.byOrder
      ).map((key) => {
        return {
          id: key,
          value: Array.isArray(this.formData.extrafield.byOrder[key])
            ? this.formData.extrafield.byOrder[key].join('/')
            : this.formData.extrafield.byOrder[key],
        }
      });

      let orderExtrafieldsBySize = [];

      if (this.hasExtrafieldsBySize) {
        this.order.customerInfos.forEach((customerInfo, index) => {
          orderExtrafieldsBySize[index] = {
            customerInfoId: customerInfo.customerInfoId,
            orderExtrafields: [],
          };

          Object.keys(customerInfo.bySizeExtrafields).forEach(() => {
            orderExtrafieldsBySize[index]['orderExtrafields'] = Object.keys(
              this.formData.extrafield.bySize[index]
            ).map((key2) => {
              return {
                id: key2,
                value: Array.isArray(
                  this.formData.extrafield.bySize[index][key2]
                )
                  ? this.formData.extrafield.bySize[index][key2].join('/')
                  : this.formData.extrafield.bySize[index][key2],
              }
            })
          })
        })
      }

      return {
        byOrderExtrafields: orderExtrafieldsByOrder,
        bySizeExtrafields: orderExtrafieldsBySize,
      }
    },
    formatOrderExtrafieldsFromCart() {
      const orderExtrafieldsByOrder = Object.keys(
        this.formData.extrafield.byOrder
      ).map((key, index) => {
        return {
          id: key,
          group: index + 1,
          Alias: '',
          value: Array.isArray(this.formData.extrafield.byOrder[key])
            ? this.formData.extrafield.byOrder[key].join('/')
            : this.formData.extrafield.byOrder[key] || '',
        }
      });

      let orderExtrafieldsBySize = [];

      if (this.hasExtrafieldsBySize) {
        this.checkoutCartParams.forEach((param, index) => {
          if (this.formData.extrafield.bySize[index]) {
            Object.keys(this.formData.extrafield.bySize[index]).forEach(
              (key) => {
                orderExtrafieldsBySize.push({
                  id: key,
                  group:
                    Object.keys(this.formData.extrafield.byOrder).length +
                    index +
                    1,
                  Alias: param.alias,
                  value: Array.isArray(
                    this.formData.extrafield.bySize[index][key]
                  )
                    ? this.formData.extrafield.bySize[index][key].join('/')
                    : this.formData.extrafield.bySize[index][key] || '',
                })
              }
            )
          }
        })
      }

      return {
        orderExtrafields: [
          ...orderExtrafieldsByOrder,
          ...orderExtrafieldsBySize,
        ],
      }
    },
    handlePayment() {
      if (!this.isPaymentProcessing) {
        this.isPaymentProcessing = true;

        let cart = {};

        const orderExtrafields =
          this.$route.name === 'checkout-unpaid'
            ? this.formatOrderExtrafieldsFromOrder()
            : this.formatOrderExtrafieldsFromCart();
        switch (this.$route.name) {
          // 活動: 一般結帳
          case 'checkout':
            if (this.checkoutCart.prepaid) {
              cart = {
                ...this.formData,
                basePrice: 0, // 折扣前價格
                total: 0, // 折扣後價格
                ...orderExtrafields,
              }
            } else {
              cart = {
                ...this.formData,
                card: this.formData.card.replace(/\s/g, ''),
                basePrice: this.checkoutCart.paramsPriceTotal, // 折扣前價格
                total: this.checkoutTotal, // 折扣後價格
                ...orderExtrafields,
                bankType: this.formData.paymentMethod === 'Vacc' ? this.formData.bankType : undefined
              }
            }
            break;
          // 活動: 由付款連結結帳
          case 'checkout-unpaid':
            cart = {
              ...this.formData,
              card: this.formData.card.replace(/\s/g, ''),
              basePrice: this.checkoutCart.paramsPriceTotal, // 折扣前價格
              total: this.checkoutTotal, // 折扣後價格
              orderId: this.$route.params.orderKey,
              ...orderExtrafields,
            };
            break;
          // 方案: 一般結帳
          case 'booking-prepaid-checkout':
            cart = {
              ...this.formData,
              card: this.formData.card.replace(/\s/g, ''),
              basePrice: this.checkoutCart.basePrice, // 折扣前價格
              total: this.checkoutCart.price, // 折扣後價格
            };
            break;
          case 'booking-prepaid-unpaid-checkout':
            cart = {
              ...this.formData,
              card: this.formData.card.replace(/\s/g, ''),
              basePrice: this.checkoutCart.basePrice, // 折扣前價格
              total: this.checkoutCart.price, // 折扣後價格
              orderId: this.$route.params.orderKey,
            };
            break;
          // 理論上不會有這個可能
          default:
            return false
        }

        this.$store
          .dispatch('booking/checkOut', {
            cart,
            productType: this.checkoutCart.product.type,
            checkoutType: this.checkoutType,
          })
          .then((data) => {
            // this.bindCardFormData

            if(this.formData.paymentMethod === 'Credit' && this.formData.autoRenew) {
              this.bindCardFormData = data.items;

              this.$nextTick(() => {
                this.$refs.cardForm.submit()
              })
            }else {
              const redirectToOrder = data.items && data.items.hasOwnProperty('id');

              redirectToOrder
                ? this.goToOrderDetail(data.items)
                : this.handle3DVerify(data.items.Result)
            }

            this.isPaymentProcessing = false
          })
          .catch((err) => {
            console.log('TCL: handlePayment -> err', err);
            this.isPaymentProcessing = false;


            const errMessage = err.data.Message || this.$t(`error.${err.status}`);

            this.$alert(
              errMessage,
              this.$t('global.LIGHT_BOX_PAYMENT_ERROR_TITLE' /* 結緣錯誤 */),
              {
                distinguishCancelAndClose: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t(
                  'global.LIGHT_BOX_PAYMENT_ERROR_TITLE' /* 結緣錯誤 */
                ),
                confirmButtonClass: 'button is-primary is-rounded',
                callback: () => {
                  this.handleToBookingProduct()
                },
              }
            )
          })
      }
    },
    handleToNextCheckoutStep() {
      window.scrollTo(0, 0);
      switch (this.step) {
        case 1:
          if (this.hasExtrafields) {
            this.handleToCheckoutStep(1.5)
          } else {
            this.handleToCheckoutStep(2)
          }
          break;
        case 1.5:
          this.handleToCheckoutStep(2);
          break;
        default:
          return false
      }
    },
    handleToPrevCheckoutStep() {
      window.scrollTo(0, 0);

      switch (this.step) {

        case 1:
          if (this.checkoutType === 'product') {
            this.$router.push(this.formatLink('booking-product'))
          } else {
            this.$router.push(this.formatLink('booking-prepaid-list'))
          }
          break;

        case 1.5:
          if (this.checkoutCart.prepaid && this.$route.name === 'checkout-unpaid') {
            this.$router.push(this.formatLink('order-detail'), { order: this.order })
          } else {
            this.handleToCheckoutStep(1)
          }
          break;

        case 2:
          if (this.hasExtrafields) {
            this.handleToCheckoutStep(1.5)
          } else {
            this.handleToCheckoutStep(1)
          }
          break;

        default:
          return false
      }
    },
    handleToCheckoutStep(stepNumber) {
      this.step = stepNumber
    },
    handleToBack() {
      if (this.step === 2) {
        this.step = 1
      } else {
        this.handleToBookingProduct();
      }
    },
    handleToBookingProduct() {
      if (this.checkoutType === 'product') {
        this.$router.push(this.formatLink('booking-product'))
      } else {
        this.$router.push(this.formatLink('booking-prepaid-list'))
      }
    },
    handleToBookingHome() {
      this.$router.push(this.formatLink('home'))
    },
    updateFormDataFromOrder() {
      this.formData = Object.assign(this.formData, this.order);
      this.formData.paymentMethod = 'Credit';

      if (
        this.$route.name === 'booking-prepaid-unpaid-checkout' ||
        this.$route.name === 'checkout-unpaid'
      ) {
        this.formData.couponCode = ''
      }
    },
    updateExtrafieldsFromOrder() {
      if (this.hasExtrafieldsByOrder) {
        this.extrafieldsByOrder.forEach((extrafield) => {
          /* if(extrafield.type === 'checkbox') {
            const value = extrafield.value || '';

            this.formData.extrafield.byOrder[extrafield.id] = extrafield.value ? value.split('/') : []
          }else { */
          this.formData.extrafield.byOrder[extrafield.id] = extrafield.value
          // }
        })
      }

      if (this.hasExtrafieldsBySize) {
        this.order.customerInfos.forEach((customerInfo, index) => {
          this.formData.extrafield.bySize[index] = {};
          Object.keys(customerInfo.bySizeExtrafields).forEach((key) => {
            this.formData.extrafield.bySize[index][customerInfo.bySizeExtrafields[key].id] = customerInfo.bySizeExtrafields[key].value;
          });
        })
      }
    },
    steps() {
      return [
        {
          text: this.$t(`global.TITLE_CHECKOUT_INFORMATION` /* 填寫結緣資訊 */),
          value: 1,
          verification: () => {
            return !(
              this.checkoutCart.prepaid &&
              this.$route.name === 'checkout-unpaid'
            )
          },
        },
        {
          text: this.$t('global.ORDER_EXTRAFIELD_TITLE' /* 填寫參與資訊 */),
          value: 1.5,
          verification: () => {
            return this.hasExtrafields
          },
        },
        {
          text: this.$t('global.TITLE_CHECKOUT_BILLING' /* 填寫付款資訊 */),
          value: 2,
          verification: () => {
            return !this.isFreeOrder
          },
        },
      ]
    },
    handleToChangeStep(index) {
      this.step = this.steps()[index].value
    },
    checkOrderValue(key) {
      const order = this.order || {};

      return !!order[key]
    },
    handleToBookingDeductUnpaid() {
      if (!this.loggedIn) {
        this.isModalDeductActive = true;
        this.deductCallBack = () => {
          this.handleDeductUnpaidSuccess()
        };
        return false
      }

      this.isDeductProcessing = true;

      const orderExtrafields = this.formatOrderExtrafieldsFromOrder();

      this.$store
        .dispatch('booking/fetchOrderDeduct', {
          orderKey: this.$route.params.orderKey,
          ...orderExtrafields,
        })
        .then(() => {
          this.handleDeductUnpaidSuccess()
        })
        .finally(() => {
          this.isDeductProcessing = false
        })
    },
    handleDeductUnpaidSuccess() {
      window.globalData.order = {
        status: 'SUCCESS',
        type: 'deduct',
      };

      this.formatLink('order-detail', { order: {} });
    },
    formatDateText() {
      if (this.formatProductType('category', this.checkoutCart.product.type) === 'light') {
        return formatLunar(`${this.checkoutCart.date}-04-04 00:00:00`);
      }
      if (this.formatProductType('category', this.checkoutCart.product.type) === 'activity') {
        return formatDate(new Date(`${this.checkoutCart.date}-${this.checkoutCart.time.date}`), 'dateSlash')
      }
    },
    formatDateSubText() {
      if (this.formatProductType('category', this.checkoutCart.product.type) === 'activity') {
        return formatLunar(`${this.checkoutCart.date}-${this.checkoutCart.time.date} 00:00:00`, 'lunar')
      } else {
        return ''
      }
    },
    buttonList(type) {
      const baseButton = [
        {
          text: this.$t('global.BACK_TO_PREVIOUS'/* 回上一步 */),
          type: 'button',
          style: 'black',
          fn: () => {
            this.handleToPrevCheckoutStep();
          },
        },
        {
          text: this.$t('global.ORDER_BACK_TO_TEMPLEHOME'/* 回宮廟首頁 */),
          type: 'button',
          style: 'black',
          fn: () => {
            this.handleToBookingHome();
          },
        },
      ];

      switch (type) {
        case 'step-1':
          return [
            {
              text: this.$t('global.ORDER_EXTRAFIELD_TITLE'/* 填寫參與資訊 */),
              type: 'button',
              style: 'primary',
              if: this.hasExtrafields,
              disabled: this.isFormValid,
              fn: () => {
                this.handleToNextCheckoutStep();
              },
            },
            {
              text: this.$t(`product.${this.cartProductType}.BUTTON_CONFIRM`/* 確認結緣 */),
              type: 'button',
              style: 'primary',
              if: !this.hasExtrafields && this.isFreeOrder,
              disabled: this.isFormValid,
              loading: this.isPaymentProcessing,
              fn: () => {
                this.handlePayment();
              },
            },
            {
              text: this.$t("global.BUTTON_CONFIRM_AND_PAY"/* 支付結緣金 */),
              type: 'button',
              style: 'primary',
              if: !this.hasExtrafields && !this.isFreeOrder,
              disabled: this.isFormValid,
              fn: () => {
                this.handleToNextCheckoutStep();
              },
            },
            ...baseButton
          ];
        case 'step-1.5':
          return [
            {
              text: this.$t(`product.${this.cartProductType}.BUTTON_CONFIRM`/* 確認結緣 */),
              type: 'button',
              style: 'primary',
              if: this.isFreeOrder,
              disabled: this.isFormValid,
              loading: this.isPaymentProcessing,
              fn: () => {
                this.handlePayment();
              },
            },
            {
              text: this.$t("global.BUTTON_CONFIRM_AND_PAY"/* 支付結緣金 */),
              type: 'button',
              style: 'primary',
              if: !this.isFreeOrder,
              disabled: this.isFormValid,
              fn: () => {
                this.handleToNextCheckoutStep();
              },
            },
            ...baseButton
          ];
        case 'step-2':
          return [
            {
              text: this.$t("global.PAYMENT"/* 付款 */),
              type: 'button',
              style: 'primary',
              loading: this.isPaymentProcessing,
              disabled: this.isFormValid,
              fn: () => {
                this.handlePayment();
              },
            },
            ...baseButton
          ];
        default:
          return []
      }
    },
    formatLink(type, data = {}) {
      switch (type) {
        case 'order-detail':
          return {
            name: 'order-detail',
            params: {
              merchantAlias: this.checkoutCart.merchantAlias,
              orderKey: this.$route.params.orderKey || data.order.id,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'prepaid-order-detail':
          return {
            name: 'prepaid-order-detail',
            params: {
              merchantAlias: this.checkoutCart.merchantAlias,
              orderKey: this.$route.params.orderKey || data.order.id,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'booking-product':
          return {
            name: 'booking-product',
            params: {
              merchantAlias: this.checkoutCart.merchantAlias,
              productType: this.checkoutCart.product.type,
              productId: this.checkoutCart.product.alias
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'booking-prepaid-list':
          return {
            name: `booking-prepaid-list`,
            params: {
              merchantAlias: this.checkoutCart.merchantAlias,
              prepaidAlias: this.checkoutCart.alias
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'home':
          return {
            name: 'home',
            params: {
              merchantAlias: this.checkoutCart.merchantAlias,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        default:
          return '';
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div class="booking-container">
      <div class="booking-section">
        <div class="subsection">
          <!--活動-->
          <div v-if="checkoutType === 'product'" class="columns is-multiline is-mobile">
            <template>
              <div
                class="cart-info column is-one-third-tablet is-full-mobile has-text-weight-medium is-size-5"
              >
                <div class="cart-info__name cart-info__name_text">{{ checkoutCart.product.name }}</div>
                <div class="cart-info__meta">
                  <div>{{ formatDateText() }} <span v-if="checkoutCart.product.type === 'puja'">{{ checkoutCart.time.title }}</span></div>
                  <div
                    v-if="formatDateSubText"
                    class="is-size-6 has-text-grey"
                    style="margin-top: 0.5rem"
                  >{{ formatDateSubText() }}</div>
                </div>
              </div>
              <div class="cart-params column is-full-mobile">
                <div class="cart-params__list cart-params__list_right">
                  <div
                    v-for="(param, paramKey) in checkoutCart.params"
                    :key="paramKey"
                    class="cart-params__item"
                  >
                    <div class="cart-params__item--left cart-params__item--left_text">
                      <div class="level">
                        <div class="level-left" :class="$style.bookingList">
                          {{ param.name }}
                          <span class="has-text-grey param-multiplier">x</span>
                          <span
                            class="is-size-6 has-text-grey-dark has-text-weight-medium quan-text"
                          >{{ param.qty }}</span>
                          <b-tag
                            v-if="param.canAutoRenew"
                            :type="'is-style-canAutoRenew'"
                            rounded
                          >
                            {{ $t(`global.CAN_AUTO_RENEW`) }}
                          </b-tag>
                        </div>
                      </div>
                    </div>
                    <div class="cart-params__item--right">
                      <div
                        class="has-text-grey-dark has-text-grey-dark-item"
                      >${{ param.price * param.qty }}</div>
                    </div>
                  </div>
                </div>
                <template>
                  <div v-if="hasCheckoutCartCouponInfo" class="cart-params__item">
                    <div
                      class="cart-params__item--left cart-params__item--left-text"
                    >{{ $t('global.SUBTOTAL'/* 小計 */) }}</div>
                    <div class="cart-params__item--right">
                      <div class="cart-item-price">${{ checkoutCart.paramsPriceBase }}</div>
                    </div>
                  </div>
                  <div v-else class="cart-params__item">
                    <div
                      class="cart-params__item--left cart-params__item--left-text"
                    >{{ $t('global.SUBTOTAL'/* 小計 */) }}</div>
                    <div class="cart-params__item--right">
                      <div class="cart-item-price">${{ checkoutCart.paramsPriceTotal }}</div>
                    </div>
                  </div>
                </template>
                <template>
                  <template v-if="hasCheckoutCartCouponInfo">
                    <div
                      v-if="checkoutCart.couponInfo.title"
                      class="cart-params__item has-text-danger"
                    >
                      <div class="cart-params__item--left">
                        {{`${$t('global.COUPON'/*優惠券*/)}（${checkoutCart.couponInfo.title}：${checkoutCart.couponInfo
                        .code}）`}}
                      </div>
                      <div class="cart-params__item--right">
                        <div>${{ checkoutCart.paramsPriceTotal - checkoutCart.paramsPriceBase }}</div>
                      </div>
                    </div>
                  </template>
                  <div v-else-if="couponInfo" class="cart-params__item has-text-danger">
                    <div
                      class="cart-params__item--left"
                    >{{`${$t('global.COUPON'/*優惠券*/)}（${couponInfo.title}：${couponInfo.code}）`}}</div>
                    <div class="cart-params__item--right">
                      <div>-${{ checkoutCart.paramsPriceTotal - checkoutTotal }}</div>
                    </div>
                  </div>
                </template>
                <div class="cart-params__item cart-total deshed-border">
                  <div
                    class="cart-params__item--left is-size-6 cart-params__item--left-total"
                  >{{ $t('global.TOTAL'/* 總計 */) }}</div>
                  <div class="cart-params__item--right">
                    <template>
                      <div
                        v-if="hasCheckoutCartCouponInfo"
                        class="has-text-primary is-size-5 has-text-weight-medium total-price-sum"
                      >${{ checkoutCart.paramsPriceTotal }}</div>
                      <div
                        v-else
                        class="has-text-primary is-size-5 has-text-weight-medium total-price-sum"
                      >
                        <span v-if="checkoutTotal === 0">{{$t('global.FREE')}}</span>
                        <span v-else>${{ checkoutTotal }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <b-steps v-model="bStep" :has-navigation="false" @input="handleToChangeStep">
        <template v-for="(stepItem, index) in formatSteps">
          <b-step-item :key="index" :clickable="bStep > index" :label="stepItem.text"></b-step-item>
        </template>
      </b-steps>
      <!--<transition name="checkout-step" appear>-->
      <!--步驟 1-->
      <div v-if="step === 1" class="booking-section">
        <template
          v-if="checkoutType === 'product' && !checkoutCart.prepaid && !hasCheckoutCartCouponInfo"
        >
          <div class="level subsection is-small">
            <h4
              class="level-left booking-section__title"
            >{{ $t('global.TITLE_CHECKOUT_COUPON'/* 優惠券代碼*/) }}</h4>
          </div>
          <div class="subsection">
            <b-field
              :class="$style['fieldNested']"
              :message="errors.first('coupon')"
              :type="{ 'is-danger': errors.has('coupon') }"
              expanded
            >
              <b-input
                v-model="couponCode"
                v-validate.disable="'checkCoupon'"
                name="coupon"
                :disabled="!!couponInfo"
                rounded
                expanded
              ></b-input>
              <div class="control">
                <b-button
                  v-if="!couponInfo"
                  type="is-primary"
                  rounded
                  :loading="couponProcessing"
                  :class="$style.couponButton"
                  class="coupon-button"
                  @click="handleValidCoupon(couponCode)"
                >{{ $t('global.USE_COUPON'/*使用優惠券*/) }}</b-button>
                <b-button v-else rounded @click="handleResetCoupon">
                  <BaseIcon name="times" />
                  <span>{{ $t('global.CLEAR_COUPON'/*清除優惠券*/) }}</span>
                </b-button>
              </div>
            </b-field>
          </div>
        </template>
        <div class="level subsection is-small">
          <h4
            class="level-left booking-section__title"
          >{{ $t('global.WRITE_ORDER_INFRO'/* 填寫結緣資訊*/) }}</h4>
        </div>
        <div class="subsection">
          <form @submit.prevent="handleToNextCheckoutStep">
            <b-field
              :label="$t('global.ORDER_TELEPHONE'/* 電話 */)"
              :class="$style['isRequired']"
              expanded

            >
              <b-field
                :class="$style['fieldNested']"
                :type="{ 'is-danger': errors.has('phoneNumber') }"
                :message="errors.first('phoneNumber') ? $t('global.VERIFICATION_PHONE'/* 請輸入正確的手機號碼格式, 09XXXXXXXX */) : ''"
              >
                <div class="control">
                  <b-button
                    outlined
                    rounded
                    class="is-select-style"
                    :disabled="isUnpaidCheckout || (checkoutType === 'prepaid' && checkOrderValue('phoneCode')) || (checkoutType ===
                'prepaid' && currentMember.phone)"
                    @click="isCodePickerActive = true"
                  >{{ formData.phoneCode }}</b-button>
                  <b-modal
                    :active.sync="isCodePickerActive"
                    :width="400"
                    :can-cancel="['escape','outside']"
                  >
                    <CountryCallingCodePicker :value.sync="formData.phoneCode" />
                  </b-modal>
                </div>
                <b-input
                  v-model="formData.phoneNumber"
                  v-validate="formData.phoneCode === '+886' ? 'required|digits:10|regex:^09' : ''"
                  :data-vv-as="$t(`product.${cartProductType}.CHECKOUT_PHONE_LABEL`/* 電話 */)"
                  name="phoneNumber"
                  placeholder="ex: 0912345678"
                  type="tel"
                  :disabled="isUnpaidCheckout || (checkoutType === 'prepaid' && checkOrderValue('phoneNumber')) || (checkoutType ===
                'prepaid' && currentMember.phone)"
                  rounded
                  expanded
                ></b-input>
              </b-field>
            </b-field>
            <b-field
              :label="$t('global.ORDER_NAME'/* 姓名 */)"
              :class="$style['isRequired']"
              expanded

            >
              <b-field
                :class="$style['fieldNested']"
                :type="{ 'is-danger': errors.has('fullName') }"
                :message="errors.first('fullName')"
              >
                <b-input
                  v-model="formData.fullName"
                  v-validate="'required'"
                  :data-vv-as="$t('global.ORDER_NAME'/* 姓名 */)"
                  name="fullName"
                  :disabled="isUnpaidCheckout || (checkoutType === 'prepaid' && checkOrderValue('fullname')) ||
                  (checkoutType ===
                'prepaid' && currentMember.fullName)"
                  placeholder="ex: 余春嬌"
                  rounded
                  expanded
                ></b-input>
                <b-select
                  v-model="formData.gender"
                  v-validate="'required'"
                  rounded
                  :disabled="isUnpaidCheckout || (checkoutType === 'prepaid' && checkOrderValue('gender')) || (checkoutType ===
                'prepaid' && currentMember.gender)"
                  class="has-radius-danger"
                  :data-vv-as="$t('global.GENDER'/* 性別 */)"
                  :placeholder="$t('global.GENDER'/* 性別 */)"
                >
                  <option value="female">{{ $t('global.FEMALE'/* 小姐 */) }}</option>
                  <option value="male">{{ $t('global.MALE'/* 先生 */) }}</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field
              :message="errors.first('email')"
              :type="{ 'is-danger': errors.has('email') }"
              :label="$t('global.ORDER_EMAIL'/* Email */)"
              :class="$style['isRequired']"

            >
              <b-input
                v-model="formData.email"
                v-validate="'required|email'"
                :data-vv-as="$t('global.ORDER_EMAIL'/* Email */)"
                name="email"
                type="email"
                :disabled="isUnpaidCheckout || (checkoutType === 'prepaid' && checkOrderValue('email')) || (checkoutType ===
                'prepaid' && currentMember.email)"
                placeholder="ex: you@mail.com"
                rounded
                expanded
              ></b-input>
            </b-field>
            <b-field
              v-if="checkoutType === 'product'"
              :message="errors.first('note')"
              :type="{ 'is-danger': errors.has('note') }"
              :label="cartProductNote.label || $t('global.ORDER_NOTE'/* 備註 */)"
              :class="{ [$style['isRequired']]: Boolean(cartProductNote.required) }"

            >
              <b-input
                v-model="formData.note"
                v-validate="{ required: Boolean(cartProductNote.required) }"
                :data-vv-as="cartProductNote.label || $t(`product.${cartProductType}.CHECKOUT_NOTE_LABEL`/* 備註 */)"
                name="note"
                rounded
                type="textarea"
              ></b-input>
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('agreeTerms') }"
              :message="errors.first('agreeTerms') ? $t('global.VERIFICATION_TERMS_OF_SERVICE'/* 請閱讀服務條款並勾選 */) : ''"
            >
              <b-checkbox
                v-model="formData.agreeTerms"
                v-validate="'required:false'"
                name="agreeTerms"
                class="clause-text"
              >
                {{ $t('global.I_HAVE_READ_AND_AGREE'/* 我已閱讀並同意 */) }}
                <a
                  @click="isTermsModalActive = true"
                >{{ $t('global.ORDER_CLAUSE'/* i保庇服務條款 */) }}</a>
              </b-checkbox>
            </b-field>
            <b-modal
              :active.sync="isTermsModalActive"
              :width="650"
              :can-cancel="['escape','outside']"
            >
              <ModalTerms @close="isTermsModalActive = false" />
            </b-modal>
            <BaseButtons :buttons="buttonList('step-1')" />
          </form>
        </div>
      </div>
      <!--步驟 1.5-->
      <div v-show="step === 1.5" class="booking-section">
        <template v-if="hasExtrafieldsByOrder">
          <div class="level subsection is-small">
            <h4
              class="booking-section__title"
            >{{$t(`product.${checkoutCart.product.type}.SIZE_EXTRAFIELD_TITLE`/*填寫參與資訊*/)}}</h4>
          </div>
          <div class="subsection">
            <BookingSectionOrder
              :input-data.sync="formData.extrafield.byOrder"
              :form-field="extrafieldsByOrder"
              :alias="'order'"
            ></BookingSectionOrder>
          </div>
        </template>
        <template v-if="hasExtrafieldsBySize">
          <div class="level subsection is-small">
            <h4
              class="booking-section__title"
            >{{$t(`product.${checkoutCart.product.type}.SIZE_EXTRAFIELD_TITLE`/*請依據參與人數分別回答以下問題*/)}}</h4>
          </div>
          <div class="subsection">
            <BookingSectionToggle
              v-for="(params, index) in checkoutCartParams"
              :key="index"
              :input-data.sync="formData.extrafield.bySize[index]"
              :form-valid.sync="toggleFormValid[index]"
              :form-field="extrafieldsBySize[index]"
              :alias="`${index}`"
              :title="params.name"
            ></BookingSectionToggle>
          </div>
        </template>
        <div class="subsection">
          <BaseButtons :buttons="buttonList('step-1.5')" />
        </div>
      </div>
      <!--步驟 2-->
      <div v-if="step === 2" class="booking-section">
        <div class="level subsection is-small">
          <h4
            class="level-left booking-section__title"
          >{{ $t('global.TITLE_CHECKOUT_BILLING'/* 填寫付款資訊 */) }}</h4>
        </div>
        <b-field class="subsection">
          <form @submit.prevent="handlePayment">
            <b-field
              class="is-style-extrafield"
              label="支付方式"
            >
              <template v-for="paymentMethod in paymentMethodOption">
                <b-radio
                  v-if="(!isDisabledCredit && paymentMethod.value === 'Credit') || paymentMethod.value !== 'Credit'"
                  :key="paymentMethod.value"
                  v-model="formData.paymentMethod"
                  v-validate="'required'"
                  :data-vv-as="paymentMethod.text"
                  name="paymentMethod"
                  :native-value="paymentMethod.value"
                  @input="formData.autoRenew = 0"
                >
                  {{paymentMethod.text}}
                </b-radio>
              </template>
            </b-field>

            <b-field
              v-if="hasRenew && formatProductType('category', checkoutCart.product.type) === 'light'"
              class="is-style-extrafield"
              label="是否自動續燈"
              expanded
            >
              <b-radio
                v-model="formData.autoRenew"
                name="autoRenew"
                :native-value="1"
                :disabled="isDisabledRenew">
                <span>{{ $t('global.AUTO_RENEW'/* 續燈 */) }}</span>
                <span v-if="isDisabledRenew">({{ $t('global.NOT_OPEN'/* 未開放 */) }})</span>
              </b-radio>
              <b-radio v-model="formData.autoRenew"
                       name="autoRenew"
                       :native-value="0">
                {{ $t('global.NOT_AUTO_RENEW'/* 不需續燈 */) }}
              </b-radio>
            </b-field>
            <div
              v-if="hasRenew && formatProductType('category', checkoutCart.product.type) === 'light' && isDisabledRenew"
              style="margin-top: -20px;margin-bottom: 30px;color: grey;"
            >*此網站非正式網站，未開放信用卡續燈</div>
            <b-field v-if="formData.paymentMethod === 'Vacc'" label="轉帳銀行" expanded>
              <b-field>
                <b-select
                  v-model="formData.bankType"
                  v-validate="'required'"
                  :message="errors.first('bankType')"
                  :type="{ 'is-danger': errors.has('bankType') }"
                  name="bankType"
                  placeholder="請選擇轉帳銀行"
                  expanded
                  rounded
                >
                  <option
                    v-for="bank in bankOption"
                    :key="bank.value"
                    :value="bank.value"
                  >{{ bank.text }}</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Credit' && formData.autoRenew === 0"
                     :message="errors.first('card')"
                     :type="{ 'is-danger': errors.has('card') }"
                     expanded
            >
              <template slot="label">
                <div class="level is-mobile">
                  <div class="level-left">{{ $t('global.CARD_NUMBER'/* 信用卡卡號 */) }}</div>
                  <div class="level-right">
                    <span
                      class="has-text-grey-light support-card-text"
                    >{{ $t('global.ACCEPTED_CARD_TYPES'/* 支援卡別 */) }}&nbsp;</span>
                    <img alt="visa" src="~@assets/images/visa.png" :class="$style.creditCard"/>
                    <img alt="mastercard" src="~@assets/images/mastercard.png" :class="$style.creditCard"/>
                    <img alt="jcb" src="~@assets/images/jcb.png" :class="$style.creditCard"/>
                  </div>
                </div>
              </template>
              <b-input
                v-model="formData.card"
                v-validate="'required|min:16'"
                v-mask="'#### #### #### ####'"
                :data-vv-as="$t('global.CARD_NUMBER'/* 信用卡卡號 */)"
                name="card"
                placeholder="XXXX XXXX XXXX XXXX"
                rounded
                type="tel"
              ></b-input>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Credit' && formData.autoRenew === 0" :label="$t('global.EXPIRATION_DATE'/* 信用卡到期年月份 */)" expanded  >
              <b-field>
                <b-select
                  v-model="formData.expMonth"
                  v-validate="'required'"
                  :message="errors.first('expMonth')"
                  :type="{ 'is-danger': errors.has('expMonth') }"
                  name="expMonth"
                  :placeholder="$t('global.MONTH'/* 月 */)"
                  expanded
                  rounded
                >
                  <option
                    v-for="month in monthOptionNum"
                    :key="month"
                    :value="`${(10 > month ) ? `0${month}` : month}`"
                  >{{ (10 > month ) ? `0${month}` : month }}</option>
                </b-select>
                <b-select
                  v-model="formData.expYear"
                  v-validate="'required'"
                  :message="errors.first('expYear')"
                  :type="{ 'is-danger': errors.has('expYear') }"
                  name="expYear"
                  :placeholder="$t('global.YEAR'/* 年 */)"
                  expanded
                  rounded
                >
                  <option
                    v-for="couter in yearOptionNum"
                    :key="couter"
                    :value="(couter + currentYear - 1).toString().substring(2,4)"
                  >{{ couter + currentYear - 1 }}</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Credit' && formData.autoRenew === 0" grouped>
              <b-field
                :message="errors.first('cvc')"
                :type="{ 'is-danger': errors.has('cvc') }"
                :label="$t('global.CVV'/* 信用卡背面末三碼 */)"
                expanded

              >
                <b-input
                  v-model="formData.cvc"
                  v-validate="'required|min:3'"
                  v-mask="['###']"
                  :data-vv-as="$t('global.CVV'/* 信用卡背面末三碼 */)"
                  name="cvc"
                  placeholder="・・・"
                  type="tel"
                  rounded
                ></b-input>
              </b-field>
              <b-field :class="$style['fieldCvcImage']">
                <img src="~@assets/images/credit-cvc.png" alt  :class="$style.creditCard"/>
              </b-field>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Credit'">
              <div class="has-text-align-justify" :class="$style.precaution">
                <BaseIcon name="exclamation" :class-name="'icon is-left is-box'" />
                <span
                  class="has-text-grey-light pay-notice-text"
                >{{ $t('global.TIP_PAYMENT_A'/* i保庇透過藍新金流進行交易，以保證您的支付安全 */) }}</span>
              </div>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Credit'">
              <div class="has-text-align-justify" :class="$style.precaution">
                <BaseIcon name="exclamation" :class-name="'icon is-left is-box'" />
                <span
                  class="has-text-grey-light pay-notice-text"
                >{{ $t('global.TIP_PAYMENT_B'/* 按下「付款」後，你將被導向一個外部網站以完成付費，此結緣僅為您保留15分鐘，請在15分鐘內完成付款程序，逾時將導致結緣失敗。 */) }}</span>
              </div>
            </b-field>
            <b-field v-if="formData.paymentMethod === 'Vacc'">
              <div class="is-text-content has-text-align-justify">
                <div :class="$style['text-tip']" style="margin-bottom: 0.5rem;">提醒您</div>▌ATM虛擬帳戶匯款
                <br />1.確認結緣之後，系統會自動產生該筆結緣的專屬虛擬帳號，買家可使用網路ATM或實體ATM轉帳。
                <br />2.取得帳號後請於1日內完成匯款，若逾期尚未完成付款程序，系統將自動將您的資料刪除。
                <br />3.您可以隨時於會員中心查詢，了解服務項目處理進度。
                <br />＊虛擬帳號的期限計算，例：若3/1訂購， 3/2 23:59之前未完成結帳，系統便會取消該筆結緣。
                <br />
                <br />
                <span :class="$style['text-tip']">
                  ▌防範詐騙小提醒： 請注意，若收到信件/電話宣稱轉帳錯誤，請提高警覺多方查證，以防歹徒詐騙。
                  <br />提醒您，ATM提款機無法做任何分期付款的設定或取消，只能提款或將存款匯出；
                  <br />請勿相信任何要求您至ATM提款機進行操作的電話！
                </span>
              </div>
            </b-field>
            <BaseButtons :buttons="buttonList('step-2')" />
          </form>
        </b-field>
      </div>
      <!--</transition>-->
      <!--<pre>
        isFieldsValid: {{ isFieldsValid }}
        isOrderExtrafieldFormValid: {{ isOrderExtrafieldFormValid }}
        isSizeExtrafieldValid: {{ isSizeExtrafieldValid }}
        isToggleFormValid: {{ isToggleFormValid }}
      </pre>-->
      <!--<pre>checkoutCart: {{ checkoutCart }}</pre>
      <pre>toggleFormValid: {{ toggleFormValid }}</pre>

      <pre>checkoutCartParams: {{ checkoutCartParams }}</pre>
      <pre>formatOrderExtrafieldsFromCart: {{ formatOrderExtrafieldsFromCart() }}</pre>
      <pre>extrafield: {{ formData.extrafield }}</pre>-->
    </div>
    <b-modal :active.sync="isModalDeductActive" :width="370" :can-cancel="['escape','outside']">
      <ModalDeduct
        :order="order"
        :form-data-extrafield-by-order="formData.extrafield.byOrder"
        :form-data-extrafield-by-size="formData.extrafield.bySize"
        :has-extrafields-by-size="hasExtrafieldsBySize"
        @close="isModalDeductActive = false"
        @login="deductCallBack"
      />
    </b-modal>
    <form
      v-if="bindCardFormData"
      ref="cardForm"
      :action="bindCardFormData.PostUrl"
      method="POST"
      hidden
    >
      <input
        v-for="(value, field) in bindCardFormData"
        :key="field"
        :name="field"
        :value="value"
      />
    </form>
  </Layout>
</template>

<style lang="scss" module>
  .fieldCvcImage {
    padding-top: 2rem;
    img {
      height: $size-button-height;
    }
  }
  .fieldNested {
    flex-wrap: wrap;
    flex-basis: 0;
    flex-grow: 1;
    :global(.help) {
      width: 100%;
    }
    :global(.is-expanded) {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
    .couponButton {
      @include mobile {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      @include mobile-smaller {
        padding-left: 0.6rem;
        padding-right: 0.6rem;
      }
    }
  }
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
  .modalWrapper {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: $size-section-border-radius;
  }
  .modalClose {
    background-color: transparent;
    &::before,
    &::after {
      background-color: $grey;
    }
    &::before {
      width: 100%;
    }
    &::after {
      height: 100%;
    }
    &:hover {
      background-color: transparent;
    }
  }
  .basePrice {
    font-size: 13px;
    text-decoration: line-through;
    margin-right: 1rem;
  }
  .text-tip {
    color: #852426;
  }
  .bookingList {
    display: flex;
    align-items: end;
  }
  .creditCard {
    pointer-events: none;
  }
  .precaution {
    display: flex;
  }
</style>
